module.exports = __webpack_public_path__ + "img/1024.da31b18c.svg";